module.exports = __webpack_public_path__ + "img/7.15ff2366.jpg";